<template>
  <div>
    <scroll-bar>
      <el-menu mode="vertical" :show-timeout="200" :default-active="$route.path" :collapse="isCollapse"
        background-color="#434A54" :unique-opened="true" text-color="#fff" active-text-color="#409EFF" style="height: 100%;">
        <!-- <a class="logo" href="http://www.yanzhaobz.com.cn/">
          <img class="logo1" src="http://www.yanzhaobz.com.cn/images/logo.png" alt="">
          <img class="logo2" src="http://www.yanzhaobz.com.cn/images/biglogo.png" alt="">
        </a> -->
        <!-- <sidebar-item :routes="routes"></sidebar-item> -->
        <SidebarItem :routes="routes"></SidebarItem>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'

  export default {
    components: {
      SidebarItem,
      ScrollBar
    },
    created() {
      console.log(this.routers)
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'routers'
      ]),
      routes() {
        // return this.$router.options.routes
        return this.routers
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue